<template>
  <div v-if="article">

    <div><Navbar :values="article" /></div>

    <div>
      <CoverStory :article="article" />
    </div>

    <div class="bg-white">

      <TextBody class="mt-5 mb-5 mb-5 white-logo trigger-container" :text="article.story.text_exc" />
      
      <TextBody class="mt-5 mb-5 mb-5 white-logo trigger-container" :text="article.story.text_3" />
        <SwiperCarousel />
    
    <TextBody class="mt-5 mb-5 mb-5 white-logo trigger-container" :text="article.story.text_gal" />
    
      <VideoScroll :mcp-id="article.story.mcp_llamadas_video" />
      
      <TextBody class="mt-5 mb-5 mb-5 white-logo trigger-container" :text="article.story.text_4" />

     
      <div style="width:90%;margin: 0 auto;border-top:1px solid lightgray;height:1px;"></div>

      <div class="mt-5 pt-5">
        <TextBody class="white-logo trigger-container" :text="article.story.text_15" />
      </div>

    </div>

    <div class="credits trigger-container">
      <TextCredits :text="article.credits" />
    </div>
  
  </div>
  
</template>

<script>

  // Localization settings
  import i18n from '@/mixins/i18n'

  import Navbar from '@/components/Navbar'
  import CoverStory from '@/components/CoverStory'
  import TextBody from '@/components/TextBody'
  import TextCredits from '@/components/TextCredits'
  import VideoScroll from '@/components/VideoScroll'
  import SwiperCarousel from '@/components/SwiperCarousel'
  

  export default {
    name: 'Home',
    mixins: [i18n],
    components: {
      CoverStory,
      Navbar,
      TextBody,
      TextCredits,
      VideoScroll,
      SwiperCarousel
    },
    props: {
      locale: {
        type: String,
        default: null
      }
    },
    beforeMount () {
      this.setLocale(this.$route.params.locale)
      window.scrollTo(0, 0)
    },
    beforeRouteUpdate (to, from, next) {
      this.setLocale(from.params.locale)
      if(to.name != 'list') {
        window.scrollTo(0, 0)        
      }        
      next()
    },
    mounted() {

      window.addEventListener('scroll', () => {

        this.logoScroll()
        
      })

    },
    computed: {
      article() {
        return require(`@/i18n/${this.locale}.json`)
      }
    },
    methods: {
      logoScroll() {

        const triggers = document.querySelectorAll('.trigger-container')

        Array.from(triggers).forEach((i)=> {

          if(i.offsetTop <= window.scrollY && (i.offsetTop+i.offsetHeight + 300) >= window.scrollY) {
            if(i.classList.contains('white-logo')) {
              document.querySelector('#uvn-logo').classList.add('white-logo')
            } else {
              document.querySelector('#uvn-logo').classList.remove('white-logo')
            }

            if(i.classList.contains('credits')) {
              document.querySelector('#nav-indicator').style.bottom = '-50px'
            } else {
              document.querySelector('#nav-indicator').style.bottom = '0'
            }
          }
        })

      }
    }
  }
</script>